import Home from "./components/Home";
import Login from "./components/Login";
import Lyrics from "./components/Lyrics";
import Thoughts from "./components/Thoughts";
import Trip from "./components/Trip";
import VueRouter from "vue-router";
import Vue from "vue";
import firebase from "firebase/app";
import "firebase/auth";
import WordCloud from "./components/WordCloud";

Vue.use(VueRouter);

const routes = [
    { path: '/', name: 'home', component: Home },
    { path: '/login', name: 'login', component: Login },
    { path: '/lyrics', name: 'lyrics', component: Lyrics },
    { path: '/thoughts', name: 'thoughts', component: Thoughts },
    { path: '/trip', name: 'trip', component: Trip },
    { path: '/cloud', name: 'cloud', component: WordCloud },
]

export const router = new VueRouter({
    mode: 'history',
    routes
})

router.beforeEach((to, from, next) => {
    const currentUser = firebase.auth().currentUser;
    if (to.name !== 'login' && !currentUser) {
        next('login')
    } else{
        next();
    }
})
